import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React, { forwardRef, useEffect, useState } from 'react';
//import CloseIcon from '@material-ui/icons';
import AppBar from '@material-ui/core/AppBar';
import Fab from '@material-ui/core/Fab';
import Toolbar from '@material-ui/core/Toolbar';
import GetAppIcon from '@material-ui/icons/GetApp';
import Typography from '@material-ui/core/Typography';
import { DownloadInvoice } from '../core/controls/components/custom/downloadshelper';

const drawerWidth = 840;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
      }
}));

function InvoiceSideBar(props, ref) {
    const [url, setUrl] = useState(null);
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(null);
    const [fileContent, setFileContent] = useState({htmlFileContent : '<span>Loading Invoice Details</span>'});
    const classes = useStyles();

    useEffect(() => {
        setOpen(props.open);
        if(props.open){
            setId(props.gridrow.InvoiceId)
            DownloadInvoice(props.gridrow.InvoiceId, props.gridrow.DownloadId, true).then(res => {
                setFileContent(res)
            });
        }

      }, [props.open]);


    const toggleDrawer = () => {
        setOpen(false);
        setId(null);
        setFileContent({htmlFileContent : '<span>Loading Invoice Details</span>'})
        props.handleInvoiceSlider();
    };

    const download = () =>{
        const downloadLink = document.createElement("a");
        downloadLink.href = fileContent.base64PDFFileContent;//dFile
        downloadLink.download = fileContent.fileName; //fileName
        downloadLink.click();
        downloadLink.remove();
    }

    return (
        <Drawer anchor={'right'} open={open} onClose={() => toggleDrawer()} classes={{
            paper: classes.drawerPaper,
        }}>
            <AppBar position="static" color='secondary'>
                <Toolbar variant="dense">
                <div className='row'>
                    <Typography variant="h6" color="inherit" >
                        Invoice Details
                    </Typography> 
                    </div>
                    <div className='flex-grow-1'></div>
                    <i className='zoom m-1'>
                        <Fab size="small" color="secondary" aria-label="Download" className="float-right" title="Download" onClick={download}>
                            <GetAppIcon fontSize="small" />
                        </Fab>
                    </i>
                    <i className='zoom m-1'>
                        <Fab size="small" color="secondary" aria-label="Close" className="float-right" title="Close" onClick={toggleDrawer}>
                            <CloseIcon fontSize="small" />
                        </Fab>
                    </i>
                    {/* <IconButton onClick={toggleDrawer}>
                        <CloseIcon />
                    </IconButton>                                */}
                </Toolbar>
            </AppBar>
            {/* <div className={classes.drawerHeader}>
                <IconButton onClick={toggleDrawer}>
                    <CloseIcon />
                </IconButton>
            </div> */}
            <div id="sampleDiv" className="pl-4" style={{ overflow: 'scroll',"paddingLeft": "90px" }}>
                <div dangerouslySetInnerHTML={{__html: fileContent.htmlFileContent}} />
            </div>

        </Drawer>
    );


}

export default forwardRef(InvoiceSideBar);
